<div *ngIf='screenWidth > 1230' class="padding-left">
  <!-- <div class="visible-lg"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-tis-support-body">
      <div class="bmw-tis-support-header">
        Contact TIS Support
      </div>
      <div class="bmw-tis-support-form">
        <div class="container bmw-no-gutter">
          <form [formGroup]='userForm' (ngSubmit)='onSubmit()'>
            <div class="bmw-form-element">
              <span for="title">Subject*</span>
              <div>
                <input type="text" id="subject" [formControl]="subject">
              </div>
              <small *ngIf="userForm.get('subject').hasError('required') && userForm.get('subject').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Prefix*</span>
              <div>
                <select id="prefix" [formControl]="prefix" name="prefix">
                  <option *ngFor='let prefix of prefixList' [ngValue]='prefix'>{{prefix}}</option>
                </select>
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Full Name*</span>
              <div>
                <input id="firstName" [formControl]="fullName" type="text">
              </div>
              <small *ngIf="userForm.get('fullName').hasError('required') && userForm.get('fullName').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Company Name*</span>
              <div>
                <input id="companyName" [formControl]="companyName" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Address 1*</span>
              <div>
                <input id="address1" [formControl]="address1" type="text">
              </div>
              <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Address 2
                <em>(Optional)</em>
              </span>
              <div>
                <input type="text" id="address2" [formControl]="address2">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">City*</span>
              <div>
                <input id="city" [formControl]="city" type="text">
              </div>
              <small *ngIf="userForm.get('city').hasError('required') && userForm.get('city').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">State/Province/Territory*</span>
              <div>
                <select id="state" [formControl]="state">
                  <option *ngFor='let state of states' [ngValue]='state'>{{state}}</option>
                </select>
              </div>
              <small *ngIf="userForm.get('state').hasError('required') && userForm.get('state').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Zip/Postal Code*</span>
              <div>
                <input type="text" id="zipCode" [formControl]="zipCode">
              </div>
              <small *ngIf="userForm.get('zipCode').hasError('required') && userForm.get('zipCode').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Phone
                <em>(Optional)</em>
              </span>
              <div>
                <input id="phone" [formControl]="phone" [imask]="phoneMask" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Email*</span>
              <div>
                <input type="text" id='email' [formControl]="email">
              </div>
              <small *ngIf="(userForm.get('email').hasError('required')  || userForm.get('email').invalid) && userForm.get('email').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Comments/Questions*</span>
              <div>
                <textarea type="text" id='comments' [formControl]="comments"></textarea>
              </div>
              <small *ngIf="(userForm.get('comments').hasError('required') && userForm.get('comments').touched)">Required</small>
            </div>
            <br>
            <br>
            <small>{{errorMessage}}</small>
            <br>
            <br>
            <div class="bmw-form-element">
              <button type="submit" [ngStyle]='{"background-color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' [disabled]='userForm.invalid'
                class="btn btn-default" class="bmw-tis-support-submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-tis-support-body">
      <div class="bmw-tis-support-header">
        Contact TIS Support
      </div>
      <div class="bmw-tis-support-form">
        <div class="container bmw-no-gutter">
          <form [formGroup]='userForm' (submit)='onSubmit()'>
            <div class="bmw-form-element">
              <span for="title">Subject*</span>
              <div>
                <input type="text" id="subject" [formControl]="subject">
              </div>
              <small *ngIf="userForm.get('subject').hasError('required') && userForm.get('subject').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Prefix*</span>
              <div>
                <select id="prefix" [formControl]="prefix" name="prefix">
                  <option *ngFor='let prefix of prefixList' [ngValue]='prefix'>{{prefix}}</option>
                </select>
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Full Name*</span>
              <div>
                <input id="firstName" [formControl]="fullName" type="text">
              </div>
              <small *ngIf="userForm.get('fullName').hasError('required') && userForm.get('fullName').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Company Name*</span>
              <div>
                <input id="companyName" [formControl]="companyName" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Address 1*</span>
              <div>
                <input id="address1" [formControl]="address1" type="text">
              </div>
              <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Address 2
                <em>(Optional)</em>
              </span>
              <div>
                <input type="text" id="address2" [formControl]="address2">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">City*</span>
              <div>
                <input id="city" [formControl]="city" type="text">
              </div>
              <small *ngIf="userForm.get('city').hasError('required') && userForm.get('city').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">State/Province/Territory*</span>
              <div>
                <select id="state" [formControl]="state">
                  <option *ngFor='let state of states' [ngValue]='state'>{{state}}</option>
                </select>
              </div>
              <small *ngIf="userForm.get('state').hasError('required') && userForm.get('state').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Zip/Postal Code*</span>
              <div>
                <input type="text" id="zipCode" [formControl]="zipCode">
              </div>
              <small *ngIf="userForm.get('zipCode').hasError('required') && userForm.get('zipCode').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Phone
                <em>(Optional)</em>
              </span>
              <div>
                <input id="phone" [formControl]="phone" [imask]="phoneMask" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Email*</span>
              <div>
                <input type="text" id='email' [formControl]="email">
              </div>
              <small *ngIf="(userForm.get('email').hasError('required')  || userForm.get('email').invalid) && userForm.get('email').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Comments/Questions*</span>
              <div>
                <textarea type="text" id='comments' [formControl]="comments"></textarea>
              </div>
              <small *ngIf="(userForm.get('comments').hasError('required') && userForm.get('comments').touched)">Required</small>
            </div>
            <div class="bmw-form-element">
              <br>
              <br>
              <small>{{errorMessage}}</small>
              <br>
              <br>
              <button type="submit" [ngStyle]='{"background-color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' [disabled]='userForm.invalid'
                class="btn btn-default" class="bmw-tis-support-submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-tis-support-body">
      <div class="bmw-tis-support-header">
        Contact TIS Support
      </div>
      <div class="bmw-tis-support-form">
        <div class="container bmw-no-gutter">
          <form [formGroup]='userForm' (submit)='onSubmit()'>
            <div class="bmw-form-element">
              <span for="title">Subject*</span>
              <div>
                <input type="text" id="subject" [formControl]="subject">
              </div>
              <small *ngIf="userForm.get('subject').hasError('required') && userForm.get('subject').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Prefix*</span>
              <div>
                <select id="prefix" [formControl]="prefix" name="prefix">
                  <option *ngFor='let prefix of prefixList' [ngValue]='prefix'>{{prefix}}</option>
                </select>
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Full Name*</span>
              <div>
                <input id="firstName" [formControl]="fullName" type="text">
              </div>
              <small *ngIf="userForm.get('fullName').hasError('required') && userForm.get('fullName').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Company Name*</span>
              <div>
                <input id="companyName" [formControl]="companyName" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Address 1*</span>
              <div>
                <input id="address1" [formControl]="address1" type="text">
              </div>
              <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Address 2
                <em>(Optional)</em>
              </span>
              <div>
                <input type="text" id="address2" [formControl]="address2">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">City*</span>
              <div>
                <input id="city" [formControl]="city" type="text">
              </div>
              <small *ngIf="userForm.get('city').hasError('required') && userForm.get('city').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">State/Province/Territory*</span>
              <div>
                <select id="state" [formControl]="state">
                  <option *ngFor='let state of states' [ngValue]='state'>{{state}}</option>
                </select>
              </div>
              <small *ngIf="userForm.get('state').hasError('required') && userForm.get('state').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Zip/Postal Code*</span>
              <div>
                <input type="text" id="zipCode" [formControl]="zipCode">
              </div>
              <small *ngIf="userForm.get('zipCode').hasError('required') && userForm.get('zipCode').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Phone
                <em>(Optional)</em>
              </span>
              <div>
                <input id="phone" [formControl]="phone" [imask]="phoneMask" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Email*</span>
              <div>
                <input type="text" id='email' [formControl]="email">
              </div>
              <small *ngIf="(userForm.get('email').hasError('required')  || userForm.get('email').invalid) && userForm.get('email').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Comments/Questions*</span>
              <div>
                <textarea type="text" id='comments' [formControl]="comments"></textarea>
              </div>
              <small *ngIf="(userForm.get('comments').hasError('required') && userForm.get('comments').touched)">Required</small>
            </div>
            <div class="bmw-form-element">
              <br>
              <br>
              <small>{{errorMessage}}</small>
              <br>
              <br>
              <button type="submit" [ngStyle]='{"background-color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' [disabled]='userForm.invalid'
                class="btn btn-default" class="bmw-tis-support-submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-tis-support-body">
      <div class="bmw-tis-support-header">
        Contact TIS Support
      </div>
      <div class="bmw-tis-support-form">
        <div class="container bmw-no-gutter">
          <form [formGroup]='userForm' (submit)='onSubmit()'>
            <div class="bmw-form-element">
              <span for="title">Subject*</span>
              <div>
                <input type="text" id="subject" [formControl]="subject">
              </div>
              <small *ngIf="userForm.get('subject').hasError('required') && userForm.get('subject').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Prefix*</span>
              <div>
                <select id="prefix" [formControl]="prefix" name="prefix">
                  <option *ngFor='let prefix of prefixList' [ngValue]='prefix'>{{prefix}}</option>
                </select>
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Full Name*</span>
              <div>
                <input id="firstName" [formControl]="fullName" type="text">
              </div>
              <small *ngIf="userForm.get('fullName').hasError('required') && userForm.get('fullName').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Company Name*</span>
              <div>
                <input id="companyName" [formControl]="companyName" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Address 1*</span>
              <div>
                <input id="address1" [formControl]="address1" type="text">
              </div>
              <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="author">Address 2
                <em>(Optional)</em>
              </span>
              <div>
                <input type="text" id="address2" [formControl]="address2">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">City*</span>
              <div>
                <input id="city" [formControl]="city" type="text">
              </div>
              <small *ngIf="userForm.get('city').hasError('required') && userForm.get('city').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">State/Province/Territory*</span>
              <div>
                <select id="state" [formControl]="state">
                  <option *ngFor='let state of states' [ngValue]='state'>{{state}}</option>
                </select>
              </div>
              <small *ngIf="userForm.get('state').hasError('required') && userForm.get('state').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Zip/Postal Code*</span>
              <div>
                <input type="text" id="zipCode" [formControl]="zipCode">
              </div>
              <small *ngIf="userForm.get('zipCode').hasError('required') && userForm.get('zipCode').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Phone
                <em>(Optional)</em>
              </span>
              <div>
                <input id="phone" [formControl]="phone" [imask]="phoneMask" type="text">
              </div>
            </div>
            <div class="bmw-form-element">
              <span for="title">Email*</span>
              <div>
                <input type="text" id='email' [formControl]="email">
              </div>
              <small *ngIf="(userForm.get('email').hasError('required')  || userForm.get('email').invalid) && userForm.get('email').touched">Required</small>
            </div>
            <div class="bmw-form-element">
              <span for="title">Comments/Questions*</span>
              <div>
                <textarea type="text" id='comments' [formControl]="comments"></textarea>
              </div>
              <small *ngIf="(userForm.get('comments').hasError('required') && userForm.get('comments').touched)">Required</small>
            </div>
            <div class="bmw-form-element">
              <br>
              <br>
              <small>{{errorMessage}}</small>
              <br>
              <br>
              <button type="submit" [ngStyle]='{"background-color": (""|brandTypePipe) ? "#bf1a22":"#1c69d4"}' [disabled]='userForm.invalid'
                class="btn btn-default" class="bmw-tis-support-submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>